import env from './env';

const nodeEnv = process.env.NODE_ENV || 'development';
export default env[nodeEnv];



// WEBPACK FOOTER //
// ./src/config/index.js